export const DrawerToggleLeftIcon = ({
  fill = 'currentColor',
  width = '24',
  height = '24',
  viewBox = '0 0 24 24',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      // eslint-disable-next-line max-len
      d="M3.50024 5.00024C3.50024 4.17182 4.17182 3.50024 5.00024 3.50024H18.9998C19.8282 3.50024 20.4998 4.17182 20.4998 5.00024V18.9998C20.4998 19.8282 19.8282 20.4998 18.9998 20.4998H5.00024C4.17182 20.4998 3.50024 19.8282 3.50024 18.9998V5.00024ZM2.49976 18.9998C2.49976 20.3805 3.61953 21.5002 5.00024 21.5002H18.9998C20.3805 21.5002 21.5002 20.3805 21.5002 18.9998V5.00024C21.5002 3.61953 20.3805 2.49976 18.9998 2.49976H5.00024C3.61953 2.49976 2.49976 3.61953 2.49976 5.00024V18.9998Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M15.5002 21V3C15.5002 2.72386 15.2761 2.49976 15 2.49976C14.7239 2.49976 14.4998 2.72386 14.4998 3V21C14.4998 21.2761 14.7239 21.5002 15 21.5002C15.2761 21.5002 15.5002 21.2761 15.5002 21Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M10.6462 8.64623C10.8415 8.45097 11.1585 8.45097 11.3537 8.64623C11.549 8.8415 11.549 9.15849 11.3537 9.35375L8.70748 12L11.3537 14.6462C11.549 14.8415 11.549 15.1585 11.3537 15.3538C11.1585 15.549 10.8415 15.549 10.6462 15.3538L7.6462 12.3538C7.45094 12.1585 7.45094 11.8415 7.6462 11.6462L10.6462 8.64623Z"
      fill={fill}
    />
  </svg>
)
